// extracted by mini-css-extract-plugin
export default {"main_header":"MainHeader_main_header__22lfr","main_title":"MainHeader_main_title__icdnb","main_icon":"MainHeader_main_icon__3Ykgu"};